import React from 'react';
import {Link} from 'react-router-dom';
import { assetPath, company, galleryImages, services } from '../../data/companyData';

export default class FooterOne extends React.Component {
    render(){
        let publicUrl = process.env.PUBLIC_URL+'/'
        const footerGallery = galleryImages.slice(0, 2);
        return (
            <>
                <footer className="footer-one-sec">
                    <div className="footer-one__pattern" style={{backgroundImage: 'url('+publicUrl+'assets/images/pattern/footer-v1-pattern.png)'}}></div>
                    <div className="footer-one__top">
                        <div className="footer-one__top-img"
                            style={{backgroundImage: 'url('+publicUrl+'assets/images/resources/footer-v1-img3.png)'}}></div>
                        <div className="container">
                            <div className="row">
                                <div className="col-xl-12">
                                    <div className="footer-one__top-inner">
                                        <div className="row">
                                            <div className="col-xl-4 col-lg-6 col-md-6 wow animated fadeInUp" data-wow-delay="0.1s">
                                                <div className="footer-widget__column footer-widget__about">
                                                    <div className="footer-widget__about-logo">
                                                        <Link to="/"><img src={assetPath("logo-fa-interior-trim-white.png")} alt={company.name} style={{maxHeight: "92px", width: "auto"}} /></Link>
                                                    </div>

                                                    <p className="footer-widget__about-text">{company.shortDescription}</p>

                                                    <div className="footer-widget__about-social-link">
                                                        <ul>
                                                            <li>
                                                                    <a href={company.social.facebook}>
                                                                    <span className="first icon-facebook-app-symbol"></span>
                                                                    <span className="second icon-facebook-app-symbol"></span>
                                                                </a>
                                                            </li>

                                                            <li>
                                                                    <a href={company.social.instagram}>
                                                                        <span className="first fab fa-instagram"></span>
                                                                        <span className="second fab fa-instagram"></span>
                                                                    </a>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="col-xl-2 col-lg-6 col-md-6 wow animated fadeInUp" data-wow-delay="0.3s">
                                                <div className="footer-widget__column footer-widget__services">
                                                    <h2 className="footer-widget__title">Our Services</h2>
                                                    <ul className="footer-widget__services-list">
                                                        {services.slice(0, 5).map((service) => (
                                                            <li className="footer-widget__services-list-item" key={service.slug}>
                                                                <Link to={service.path}>{service.title}</Link>
                                                            </li>
                                                        ))}
                                                    </ul>
                                                </div>
                                            </div>

                                            <div className="col-xl-2 col-lg-6 col-md-6 wow animated fadeInUp" data-wow-delay="0.5s">
                                                <div className="footer-widget__column footer-widget__explore">
                                                    <h2 className="footer-widget__title">Explore</h2>
                                                    <ul className="footer-widget__explore-list">
                                                        <li className="footer-widget__explore-list-item"><Link to="/">Home</Link></li>
                                                        <li className="footer-widget__explore-list-item"><Link to="/about">About</Link></li>
                                                        <li className="footer-widget__explore-list-item"><Link to="/services">Services</Link></li>
                                                        <li className="footer-widget__explore-list-item"><Link to="/gallery">Gallery</Link></li>
                                                        <li className="footer-widget__explore-list-item"><Link to="/contact">Contact Us</Link></li>
                                                    </ul>
                                                </div>
                                            </div>

                                            <div className="col-xl-4 col-lg-6 col-md-6 wow animated fadeInUp" data-wow-delay="0.7s">
                                                <div className="footer-widget__column footer-widget__posts">
                                                    <h2 className="footer-widget__title">Featured Work</h2>
                                                    <div className="footer-widget__posts-list">
                                                        <ul>
                                                            {footerGallery.map((item) => (
                                                            <li key={item.src}>
                                                                <div className="img-box">
                                                                    <img src={assetPath(item.src)} alt={item.title} />
                                                                    <div className="overlay-icon">
                                                                        <Link to={process.env.PUBLIC_URL + `/gallery`}><span className="icon-link"></span></Link>
                                                                    </div>
                                                                </div>

                                                                <div className="text-box">
                                                                    <p><Link to={process.env.PUBLIC_URL + `/gallery`}>{item.title}</Link></p>
                                                                    <span>{item.category}</span>
                                                                </div>
                                                            </li>
                                                            ))}
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="footer-one__bottom clearfix">
                        <div className="container">
                            <div className="row">
                                <div className="col-xl-12">
                                    <div className="footer-one__bottom-inner">
                                        <div className="footer-one__bottom-text">
                                            <p>Copyright &copy;2026. All rights reserved to <Link to="/">{company.name}</Link></p>
                                        </div>

                                        <div className="footer-one__bottom-list">
                                            <ul>
                                                <li><Link to="/services">Services</Link></li>
                                                <li><Link to="/gallery">Gallery</Link></li>
                                                <li><Link to="/contact">Free Estimate</Link></li>
                                            </ul>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </footer>
            </>
        )
    }
}
